import Layout from '@/layout'

const userCenter = {
  path: '/user-center',
  component: Layout,
  title: '个人中心',
  name: 'UserCenter',
  redirect: '/user-center/index',
  meta: { title: '个人中心', name: 'UserCenter' },
  children: [
    {
      path: 'index',
      name: 'UserInfo',
      component: () => import('@/views/UserCenter/UserInfo.vue'),
      meta: { title: '个人信息修改' }
    },
    {
      path: 'mail-list',
      name: 'MailList',
      component: () => import('@/views/UserCenter/MailList.vue'),
      meta: { title: '通讯录', hidden: true }
    },
    {
      path: 'my-payment',
      name: 'MyPayment',
      component: () => import('@/views/UserCenter/MyPayment.vue'),
      meta: { title: '我的缴费', hidden: true }
    },
    {
      path: 'reward-records',
      name: 'RewardRecords',
      component: () => import('@/views/UserCenter/RewardRecords.vue'),
      meta: { title: '我的奖惩记录', hidden: true }
    },
    {
      path: 'study-experience',
      name: 'StudyExperience',
      component: () => import('@/views/UserCenter/StudyExperience.vue'),
      meta: { title: '我的学习心得', hidden: true }
    },
    {
      path: 'examination-experience',
      name: 'ExaminationExperience',
      component: () => import('@/views/UserCenter/ExaminationExperience.vue'),
      meta: { title: '我的备考心得', hidden: true }
    },
    {
      path: 'change-password',
      name: 'ChangePassword',
      component: () => import('@/views/UserCenter/ChangePassword.vue'),
      meta: { title: '密码修改' }
    },
    {
      path: 'resource-exchange',
      name: 'ResourceExchange',
      component: () => import('@/views/UserCenter/ResourceExchange.vue'),
      meta: { title: '资源交流信息', hidden: true }
    },
    {
      path: 'payInfo',
      name: 'payInfo',
      component: () => import('@/views/UserCenter/payInfo.vue'),
      meta: { title: '我的缴费', hidden: true }
    }
  ]
}

export default userCenter
